export const socialsData = {
    github: 'https://github.com/sreerag-rajan',
    facebook: 'https://www.facebook.com/obgynhyd',
    linkedIn: 'https://www.linkedin.com/in/sreerag-rajan-55383a222',
    instagram: 'https://instagram.com/dr.sindhushagundlapally?igshid=YzAyZWRlMzg=',
    codepen: '',
    twitter: '',
    reddit: '',
    blogger: '',
    medium: 'https://medium.com/@sreerag.rajan5',
    stackOverflow: '',
    gitlab: '',
    youtube: ''
}